/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SsoRedirectUrlRequest {
    getFixupPrototypeFunction() { return SsoRedirectUrlRequest.fixupPrototype; }

    static newInstance(model: Partial<SsoRedirectUrlRequest>): SsoRedirectUrlRequest {
        let obj = Object.assign(new SsoRedirectUrlRequest(), model);
        SsoRedirectUrlRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SsoRedirectUrlRequest>): SsoRedirectUrlRequest {
        if (!model) return null;
        return SsoRedirectUrlRequest.newInstance(<SsoRedirectUrlRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SsoRedirectUrlRequest) {
        if (!obj) return;

        models.SsoRedirectUrlRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SsoRedirectUrlRequest): boolean {
        Object.setPrototypeOf(obj, SsoRedirectUrlRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * The unique email ID of the user.
     */
    email_id: string;

    /**
     * The URL to which the user will be redirected after authentication.
     */
    redirect_url: string;

    /**
     * The source system, application, or workflow initiating the SSO request.
     */
    source: string;

}
